import { gql } from '@apollo/client';

export const GET_INITIAL_STATE = gql`
  query GetInitialState {
    drawerOpen @client
  }
`;

export const GET_RESET_STATE = gql`
  query GetResetState {
    settingsSidebarOpen @client
  }
`;

export const GET_DRAWER_STATE_CLIENT = gql`
  query GetDrawerState {
    drawerOpen @client
  }
`;

export const GET_SETTINGS_SIDEBAR_STATE = gql`
  query GetSettingSidebarState {
    settingsSidebarOpen @client
  }
`;
